import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "../../components/app-toast";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import { APP_PATH } from "../../api/backendPath";
import { ACTIONS_GET_MEDICAL_ORDERS } from "../../action-types/actions";

export const getMedicalOrders = createAsyncThunk(
  ACTIONS_GET_MEDICAL_ORDERS.getMedicalOrders,
  async ({ page = 1, limit = 10 }, { rejectWithValue }) => {
    const axiosPrivate = await useAxiosPrivate();

    try {
      const response = await axiosPrivate.get(
        `${process.env.REACT_APP_API_URL}${APP_PATH.medicalOrders}?page=${page}&limit=${limit}`,
      );

      if (response?.data?.status === true || response?.status === 200) {
        return response.data;
      } else {
        toast.error(
          response?.data?.message || "Failed to fetch medical orders",
        );
        return rejectWithValue(response.data);
      }
    } catch (error) {
      console.error("Error fetching medical orders:", error);
      const errMsg =
        error?.response?.data?.message ||
        "Something went wrong while fetching medical orders";
      toast.error(errMsg);
      return rejectWithValue(errMsg);
    }
  },
);
